import { Accordion, AccordionSummary, AccordionDetails, Chip } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { H6 } from '../../themes/typography';

export default function FilterAccordion({
    label,
    children,
    defaultExpanded = false,
    activeCount = 0
}) {
    return (
        <Accordion
            defaultExpanded={defaultExpanded}
            sx={{
                width: '100%',
                background: 'transparent',
                boxShadow: 'none',
                borderRadius: 0,
                borderBottom: '1px solid var(--divider-color)'
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMore sx={{ color: 'var(--quaternary-color)' }} />}
                sx={{
                    minHeight: '64px',
                    display: 'flex',
                    alignItems: 'center',
                    '& .MuiAccordionSummary-content': { gap: '0.75rem' }
                }}
            >
                <H6>{label}</H6>
                {activeCount > 0 && <CustomChip label={activeCount} />}
            </AccordionSummary>
            <AccordionDetails
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '0.75rem',
                    paddingTop: '0'
                }}
            >
                {children}
            </AccordionDetails>
        </Accordion>
    );
}

function CustomChip({ label = '22' }) {
    return (
        <Chip
            label={label}
            sx={{
                backgroundColor: 'var(--secondary-color)',
                height: '26px',
                color: 'var(--quaternary-color)',
                fontWeight: '700'
            }}
        />
    );
}